import styled, {css} from "styled-components"

const StyledDiv = styled.div`
  width: 600px;
  margin: 0 auto;
  padding-bottom: ${({theme}) => theme.spacing.two};
`

export default StyledDiv

export const LoadingWrapper = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.one} ${theme.spacing.one};
  `}
`
